var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegalEntityM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.916077C5.292 0.916077 4 2.91608 4 4.91608C4 6.91608 5 9.91608 8 9.91608C11 9.91608 12 6.91608 12 4.91608C12 2.91608 10.707 0.916077 8 0.916077ZM8 2.91608C9.805 2.91608 10 4.31508 10 4.91608C10 5.03808 9.977 7.91608 8 7.91608C6.023 7.91608 6 5.03808 6 4.91608C6 4.31508 6.195 2.91608 8 2.91608Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58091 12.2345C3.41478 12.8152 1.50055 14.165 0.227 16.0761L0 16.4161V18.9161H5.4296L5.77269 16.9161H2.079C3.15087 15.4538 4.70949 14.4542 6.45282 14.0799L6.55039 13.9186L5.58091 12.2345Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44909 13.916L9.54832 14.0801C11.2912 14.4543 12.8494 15.4533 13.921 16.9161H10.2284L10.5715 18.9161H16V16.4161L15.773 16.0761C14.4991 14.1645 12.5842 12.8145 10.4173 12.234L9.44909 13.916Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49956 13.5617L8.49988 13.5617L9.61827 11.619L9.11811 10.9161L6.88132 10.9161L6.38116 11.619L7.49956 13.5617Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72166 14.2732L7.16887 14.696L6.33008 19.5856L6.47065 19.9974L7.58904 21.0839H8.41347L9.53186 19.9974L9.67243 19.5856L8.83364 14.696L8.28085 14.2732H7.72166Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalEntityM);
export default __webpack_public_path__ + "static/media/legal-entity-M.8af63e6ea5853347dfbc2a5eca288504.svg";
export { ForwardRef as ReactComponent };